import { render, staticRenderFns } from "./IntelligenceShell.vue?vue&type=template&id=f62bf920&scoped=true"
import script from "./IntelligenceShell.vue?vue&type=script&lang=js"
export * from "./IntelligenceShell.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceShell.vue?vue&type=style&index=0&id=f62bf920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62bf920",
  null
  
)

export default component.exports